import { render, staticRenderFns } from "./TableCellOrderOrderStatus.vue?vue&type=template&id=4ab61f12&scoped=true"
import script from "./TableCellOrderOrderStatus.vue?vue&type=script&lang=js"
export * from "./TableCellOrderOrderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab61f12",
  null
  
)

export default component.exports